import styled from 'styled-components';

const colorTheme = {
  secondary: '#1b7bdd',
  red: '#ce445b',
  green: '#1ba39c',
};

export const Subscription = styled.div`
  &.subscribe {
    background-color: ${({ color }) => colorTheme[color]};
    color: #fff;
    z-index: 2;
    .sub-content {
      width: 244px;
      height: 100%;
      display: flex;
      flex-flow: column;
      justify-content: center;
    }

    p {
      margin: 0 0 1.5rem;
      color: #fff;
      letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '1.29px')};
    }

    h2,
    h3 {
      text-transform: none;
      line-height: ${({ dir }) => (dir === 'rtl' ? '40px' : '28px')};
      font-size: ${({ dir }) => (dir === 'rtl' ? '30px' : '25px')};
      margin: ${({ dir }) => (dir === 'rtl' ? '0 0 1rem' : '0 0 1.5rem')};
    }

    .cta {
      display: flex;
      flex-flow: column;
      justify-content: center;
    }

    @media (min-width: 1200px) {
      padding: ${({ dir }) => (dir === 'rtl' ? '0 78px 0 0' : '0 0 0 78px')};
      width: 30%;
    }

    @media (max-width: 1199px) {
      padding: 0 30px;
      width: 100%;
      order: -1;

      .sub-content {
        width: 100%;
        flex-flow: row;
        justify-content: space-between;
        padding: 30px 0;

        h2 {
          margin-bottom: 0;
        }

        p {
          padding: 10px 50px 0;
          margin-bottom: 0;
          @media (max-width: 767.98px) and (min-width: 480px) {
            padding: 10px 30px 0;
          }
        }
      }
    }

    @media (max-width: 575.98px) {
      padding: 0 24px;
      .sub-content {
        margin: 0 auto;
        flex-flow: column;
        text-align: center;
        padding: 40px 0;
        align-items: center;

        p {
          margin: 0 0 24px;
          line-height: 20px;
          padding: 16px 0px 0;
        }
      }
    }
  }
`;
